module.exports = __webpack_public_path__ + "static/media/0121_LE_PLAFOND_HAUTEUR_2300.4cda5748.png";